import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavController, ModalController} from 'ionic-angular';

import { Globals } from '../../providers/globals';
import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';

import { ConsumerBusinessDetailPage } from '../../pages/consumer-business-detail/consumer-business-detail';
import { ConsumerBusinessMainPage } from '../../pages/consumer-business-main/consumer-business-main';  
import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';	

import { ConsumerAddMoneyPage } from '../../pages/consumer-add-money/consumer-add-money';

import { ConsumerBusinessMainHandlerProvider } from '../../providers/consumer-business-main-handler';

@Component({
  selector: 'business-card',
  templateUrl: 'business-card.html'
})
export class BusinessCardComponent {
  @Input('business') business;

  filePath: any;
  isPinned: any = false;

  constructor(
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public consumerBusinessHandlerProvider: ConsumerBusinessHandlerProvider,
    public pushNotificationHandlerProvider: PushNotificationHandlerProvider,
    public consumerBusinessMainHandlerProvider: ConsumerBusinessMainHandlerProvider, 
  	public globals: Globals
  ) {
    this.filePath = this.globals.fileUrl;
  }

  ngOnInit() {
    if(this.business.IsPinned){
    	this.isPinned = true;
    }    
  }  

  gotoDetail(event, business){
    this.navCtrl.push(ConsumerBusinessDetailPage, {
      business: business,
      caller: this
    });
  }

  gotoAddMoney($ev, business){
    this.navCtrl.push(ConsumerAddMoneyPage, {
      business: business
    });
  }

  pin(){	
  	if(this.isPinned){
  		this.isPinned = false;	
  	}else{
  		this.isPinned = true;	
  	}  		 

  	var params = {
  		businessId: this.business.Id,
  		pinned: this.isPinned
  	}

  	this.consumerBusinessHandlerProvider.pinBusiness(params, ()=>{
      if(this.isPinned){
        this.pushNotificationHandlerProvider.subscribeToBusiness(this.business.Id)  
      }else{
        this.pushNotificationHandlerProvider.unsubscribeToBusiness(this.business.Id)  
      }      
    })
  }  
}



// WEBPACK FOOTER //
// ./src/components/business-card/business-card.ts